import { Button } from '@thanx/uikit/button'
import { useStyletron } from '@thanx/uikit/theme'
import orderingDeliveryLocation from 'assets/images/cms/ordering-delivery-location.svg'
import { buildTranslate } from 'locales'
import React from 'react'

type Props = {
  isLoading: boolean
  disabled?: boolean
}

const t = buildTranslate('cms.settings.delivery_default_logic')

const Sidebar: React.FC<Props> = ({ isLoading, disabled }) => {
  const [css] = useStyletron()

  return (
    <>
      <Button
        type="submit"
        className={`mb-xxxl ${css({ width: '200px' })}`}
        isLoading={isLoading}
        disabled={disabled}
      >
        {t('publish')}
      </Button>
      <img
        className={`mb-xl ${css({
          width: '200px',
        })}`}
        src={orderingDeliveryLocation}
        alt={t('sidebar_preview')}
      />
    </>
  )
}

export default Sidebar
